export default __webpack_public_path__ + "static/media/what-02.ee52b074.png";